module.exports = __webpack_public_path__ + "img/carol-couto.92c09cf7.png";